import {
  collection,
  query,
  where,
  getCountFromServer,
} from 'firebase/firestore';
import { db } from './firebase';

/**
 * getCollectionCount
 * Returns the count of documents in a collection matching field == value using Firestore's count aggregation.
 */
export async function getCollectionCount(collectionName, fieldName, value) {
  const collectionRef = collection(db, collectionName);
  const filteredQuery = query(collectionRef, where(fieldName, '==', value));
  const aggregateSnapshot = await getCountFromServer(filteredQuery);
  return aggregateSnapshot.data().count || 0;
}
